var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileData)?_c('img',{attrs:{"src":_vm.fileData.fields.file.url,"alt":_vm.fileData.fields.description}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }